import { isMoment } from 'moment';

import type { FixedTime } from '../EditEdutainmentModal/types';

export const validateFixedScheduleField = (args: {
  fixedSchedule: FixedTime[];
  value: FixedTime[keyof FixedTime];
  fieldKey: [number, keyof FixedTime];
}) => {
  const {
    fixedSchedule,
    value,
    fieldKey: [index, fieldName],
  } = args;

  const rowData = fixedSchedule[index];
  const shouldValidate = fieldName !== 'isDayChecked' && rowData.isDayChecked;

  if (fieldName === 'isDayChecked' || !shouldValidate) {
    return Promise.resolve();
  }

  const isInvalidPlace = fieldName === 'place' && !value;
  const isInvalidAddress =
    rowData.place === '其他' && fieldName === 'address' && !value;
  const isInvalidTime =
    fieldName === 'startTime' || fieldName === 'endTime'
      ? !isMoment(value)
      : false;

  if (isInvalidPlace || isInvalidAddress || isInvalidTime) {
    return Promise.reject(new Error('必填欄位'));
  }

  const isTime = fieldName === 'startTime' || fieldName === 'endTime';
  if (!isTime) {
    return Promise.resolve();
  }

  const startTime = fieldName === 'startTime' ? value : rowData.startTime;
  const endTime = fieldName === 'endTime' ? value : rowData.endTime;

  const validTimeRange = isMoment(startTime) && isMoment(endTime);

  if (validTimeRange && startTime.isSameOrAfter(endTime, 'minute')) {
    return Promise.reject(new Error('結束時間需晚於起始時間'));
  }

  return Promise.resolve();
};

export const validateIfAllFieldsEmpty = (fixedSchedule: FixedTime[]) => {
  const isAllEmpty = fixedSchedule
    ? fixedSchedule.every((rowData) => !rowData.isDayChecked)
    : true;
  if (isAllEmpty) {
    return Promise.reject('需至少選擇一天填寫');
  }
  return Promise.resolve();
};
